import React from 'react';
import moment from 'moment';
import { observer, Observer, Provider, inject } from 'mobx-react';
import { observable, computed, action } from 'mobx';
import sizeMe from 'react-sizeme';
import { AllotmentCalendar } from './AllotmentCalendar';

import * as dates from '../../translate/dates';

function countParts(arr) {
  let parts = [];
  for(let p of arr) {
    if(!parts[parts.length - 1] || parts[parts.length-1].part !== p) {
      parts.push({part: p, count: 1});
    } else {
      parts[parts.length - 1].count++;
    }
  }
  return parts;
}

function countClassesParts(arr) {
  let parts = [];
  for(let p of arr) {
    let partPresence = p.length > 0 ? 1 : 0;
    if(!parts[parts.length - 1] || parts[parts.length-1].part !== partPresence) {
      parts.push({part: partPresence, count: 1, classes: p});
    } else {
      parts[parts.length - 1].count++;
    }
  }
  return parts;
}

@inject(models => {
  return {
    highlight: models.sharedModel.highlight,
  }
})
@observer
class HighlightTable extends React.Component {
  render() {
    const {highlight, firstDate} = this.props;
    let date = moment(firstDate);
    let contFgHighlightCells = [];
    let highlightMap = [];

    for(let i = 0; i < 7; i++) {
      let stabDate = moment(date);

      let isHighlight = false;
      for(let hlItem of highlight) {
        if(moment(hlItem.start).isSame(date, 'day') || 
            moment(hlItem.start).isBefore(date) && date.isSameOrBefore(moment(hlItem.end).hours(0).minutes(0), 'day')) {
          isHighlight = true;
          break;
        }
      }
      highlightMap.push(isHighlight ? 1 : 0);

      date.add({days: 1});
    }
    
    let keyId = 0;
    for(let part of countParts(highlightMap)) {
      if(part.part === 0) {
        contFgHighlightCells.push(<td colSpan={part.count} key={'a'+keyId++}></td>)
      } else {
        contFgHighlightCells.push(
          <td colSpan={part.count} className="fc-highlight" key={'b'+keyId++}></td>
        );
      }
    }  
    return(
      <table>
        <tbody>
          <tr>
            {contFgHighlightCells}
          </tr>              
        </tbody>
      </table>  
    )
  }
}

@observer
class Row extends React.Component {

  render() {
    const { height, firstDate, selection, selected, unavailable, updt, mainMonth, onDayMouseOver, onDayClick } = this.props;
    let date = moment(firstDate);

    let bgCells = [];
    let fgCells = [];
    let contHeadCells = [];
    let contBodySelectionCells = [];
    let contBodySelectedCells = [];
    let contBgUnavailableCells = [];
    let contBgUpdtCells = [];
    


    let selectionMap = [];
    let unavailableMap = [];
    let updtMap = [];
    let selectedMap = [];


    for(let i = 0; i < 7; i++) {
      let stabDate = moment(date);
      let isToday = moment(stabDate).isSame(moment(), 'day');
      bgCells.push(
        <td className={"fc-day fc-widget-content fc-mon fc-past"} data-date={date.format('YYYY-MM-DD')} key={date.format('YYYY-MM-DD')}></td>
      )
      fgCells.push(
        <td 
          className="fc-day fc-widget-content fc-mon fc-past" 
          data-date={date.format('YYYY-MM-DD')} 
          onMouseOver={() => {onDayMouseOver && onDayMouseOver(stabDate);}}
          onClick={() => {onDayClick && onDayClick(stabDate);}}
          key={date.format('YYYY-MM-DD')}></td>
      )
      contHeadCells.push(
        <td className={"fc-day-top fc-mon fc-past" + (date.month() !== parseInt(mainMonth) ? '' /*' fc-other-month'*/ : '') + (isToday ? " fc-today" : "")} data-date={date.format('YYYY-MM-DD')} key={date.format('YYYY-MM-DD')}>
          <span className="fc-day-number">{date.format('D.M.')}</span>
        </td>
      )
      
      selectionMap.push((selection && 
        (moment(selection.start).isSame(date, 'day') || 
          moment(selection.start).isBefore(date) && date.isSameOrBefore(moment(selection.end).hours(0).minutes(0), 'day'))) ? 1 : 0);
      selectedMap.push((selected && 
        (moment(selected.start).isSame(date, 'day') || 
          moment(selected.start).isBefore(date) && date.isSameOrBefore(moment(selected.end).hours(0).minutes(0), 'day'))) ? 1 : 0);


      let isUnavailable = false;
      for(let unavailableItem of unavailable) {
        if(moment(unavailableItem.start).isSame(date, 'day') || 
            moment(unavailableItem.start).isBefore(date) && date.isSameOrBefore(moment(unavailableItem.end).hours(0).minutes(0), 'day')) {
          isUnavailable = true;
          break;
        }
      }
      unavailableMap.push(isUnavailable ? 1 : 0);

      let isUpdt = false;
      for(let updtItem of updt) {
        if(moment(updtItem.start).isSame(date, 'day') || 
            moment(updtItem.start).isBefore(date) && date.isSameOrBefore(moment(updtItem.end).hours(0).minutes(0), 'day')) {
          isUpdt = true;
          break;
        }
      }
      updtMap.push(isUpdt ? 1 : 0);

      date.add({days: 1});
    }
    let keyId = 0;
    for(let part of countParts(selectionMap)) {
      if(part.part === 0) {
        contBodySelectionCells.push(<td colSpan={part.count} key={'a'+keyId++}></td>)
      } else {
        contBodySelectionCells.push(
          <td className="fc-event-container" colSpan={part.count} key={'b'+keyId++}>
            <a className="fc-day-grid-event fc-h-event fc-event fc-start fc-not-end calendar-selection">
                <div className="fc-content"> <span className="fc-title">&nbsp;</span></div>
            </a>
          </td>
        );
      }
    }
    for(let part of countParts(selectedMap)) {
      if(part.part === 0) {
        contBodySelectedCells.push(<td colSpan={part.count} key={'a'+keyId++}></td>)
      } else {
        contBodySelectedCells.push(
          <td className="fc-event-container" colSpan={part.count} key={'b'+keyId++}>
            <a className="fc-day-grid-event fc-h-event fc-event fc-start fc-not-end calendar-selected">
                <div className="fc-content"> <span className="fc-title">&nbsp;</span></div>
            </a>
          </td>
        );
      }
    }    

    for(let part of countParts(updtMap)) {
      if(part.part === 0) {
        contBgUpdtCells.push(<td colSpan={part.count} key={'a'+keyId++}></td>)
      } else {
        contBgUpdtCells.push(
          <td colSpan={part.count} className="calendar-updt fc-bgevent" key={'b'+keyId++}></td>
        );
      }
    } 

    for(let part of countParts(unavailableMap)) {
      if(part.part === 0) {
        contBgUnavailableCells.push(<td colSpan={part.count} key={'a'+keyId++}></td>)
      } else {
        contBgUnavailableCells.push(
          <td colSpan={part.count} className="calendar-already-rent fc-bgevent" key={'b'+keyId++}></td>
        );
      }
    } 

   

    return (
      <div className="fc-row fc-week fc-widget-content" style={{ overflow: 'hidden', height }}>
        <div className="fc-bg">
          <table className="">
            <tbody>
              <tr>
                {bgCells}
              </tr>
            </tbody>
          </table>
        </div>
        <div className="fc-content-skeleton">
          <table>
            <thead>
              <tr>
                {contHeadCells}
              </tr>
            </thead>
            <tbody>
              <tr>
                {contBodySelectedCells}
              </tr>              
              <tr>
                {contBodySelectionCells}
              </tr>
            </tbody>            
          </table>
        </div>
        <div className="fc-bgevent-skeleton">
          <table>
            <tbody>
              <tr>
                {contBgUpdtCells}
              </tr>              
            </tbody>
          </table>
        </div>        
        <div className="fc-bgevent-skeleton">
          <table>
            <tbody>
              <tr>
                {contBgUnavailableCells}
              </tr>              
            </tbody>
          </table>
        </div>
        <div className="fc-highlight-skeleton">
          <HighlightTable firstDate={firstDate} />        
        </div>
        <div className="fc-bg fc-fg">
          <table className="">
            <tbody>
              <tr>
                {fgCells}
              </tr>
            </tbody>
          </table>
        </div>        
      </div>
    )
  }
}

@observer
class RowsBare extends React.Component {
  componentWillMount() {
    this.props.onWidthChanged && this.props.onWidthChanged(this.props.size.width);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.size.width !== nextProps.size.width) {
      this.props.onWidthChanged && this.props.onWidthChanged(nextProps.size.width);
    }
  }

  render() {
    const { rowHeight, firstDate, mainMonth, selection, selected, unavailable, updt, onDayMouseOver, onDayClick } = this.props;
    let date = moment(firstDate).hours(0).minutes(0).seconds(0);
    //console.log(`First date of the calendar is: ${date.format('YYYY-MM-DD HH:mm')}`);
    let rows = [];
    for (let i = 0; i < 6; i++) {
      rows.push(
        <Row 
          height={rowHeight} 
          key={i} 
          firstDate={moment(date)} 
          mainMonth={mainMonth} 
          selection={selection}
          selected={selected} 
          unavailable={unavailable} 
          updt={updt} 
          onDayMouseOver={onDayMouseOver}
          onDayClick={onDayClick} />
      );
      date.add({ days: 7 });
    }
    return (
      <div className="fc-day-grid fc-unselectable">
        {rows}
      </div>
    );
  }
}

const Rows = sizeMe()(RowsBare);

@observer
class AllotmentCalendarMonthBare extends React.Component {
  @observable rowsWidth;
  handleRowsWidthChanged = (width) => {
    this.rowsWidth = width;
  }

  getFirstDate() {
    if(!this.props.defaultDate) {
      return moment();
    }
    let date = moment(this.props.defaultDate);
    while (date.day() !== 1) {
      // Look for monday
      date.subtract({ days: 1 });
    }
    return date;
  }

  getMonthSpan(firstDate) {
    let date = moment(firstDate);
    let months = [];
    for(let i = 0; i < 42; i++) {
      if(months.indexOf(date.month()) === -1) {
        months.push(date.month());
      }
      date.add({days: 1});
    }
    return months;
  }

  getMonthCount(firstDate) {
    let date = moment(firstDate);
    let months = {};
    for(let i = 0; i < 42; i++) {
      if(!months[date.month()]) {
        months[date.month()] = 1;
      } else {
        months[date.month()]++
      }
      date.add({days: 1})
    }
    return months;
  }

  getMainMonth(monthCounts) {
    let mainMonth;
    let dayCount = 0;
    for(let k in monthCounts) {
      let v = monthCounts[k];
      if(dayCount < v) {
        dayCount = v;
        mainMonth = k;
      }
    }
    return mainMonth;
  }

  render() {
    const firstDate = this.getFirstDate();
    const monthSpan = this.getMonthSpan(firstDate);
    const monthCount = this.getMonthCount(firstDate);
    const mainMonth = this.getMainMonth(monthCount);
    const {monthNames, selection, selected, unavailable, updt, onDayMouseOver, onDayClick} = this.props;

    const { width } = this.props.size;
    const dayNS = this.props.dayNamesShort;
    return (
      <div className="full-calendar-root fc fc-unthemed fc-ltr">
        <div className="fc-toolbar fc-header-toolbar">
          <div className="fc-left"></div>
          <div className="fc-right"></div>
          <div className="fc-center">
            <h2>{monthSpan.map(m => monthNames[m]).join(' \u2013 ')} {firstDate.year()}</h2>
          </div>
          <div className="fc-clear"></div>
        </div>
        <div className="fc-view-container">
          <div className="fc-view fc-month-view fc-basic-view">
            <table className="">
              <thead className="fc-head">
                <tr>
                  <td className="fc-head-container fc-widget-header">
                    <div className="fc-row fc-widget-header" /*style={{borderRightWidth: 1, marginRight: 16}}*/>
                      <table className="" style={{ width: this.rowsWidth }}>
                        <thead>
                          <tr>
                            <th className="fc-day-header fc-widget-header fc-mon"><span>{dayNS[1]}</span></th>
                            <th className="fc-day-header fc-widget-header fc-tue"><span>{dayNS[2]}</span></th>
                            <th className="fc-day-header fc-widget-header fc-wed"><span>{dayNS[3]}</span></th>
                            <th className="fc-day-header fc-widget-header fc-thu"><span>{dayNS[4]}</span></th>
                            <th className="fc-day-header fc-widget-header fc-fri"><span>{dayNS[5]}</span></th>
                            <th className="fc-day-header fc-widget-header fc-sat"><span>{dayNS[6]}</span></th>
                            <th className="fc-day-header fc-widget-header fc-sun"><span>{dayNS[0]}</span></th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody className="fc-body">
                <tr>
                  <td className="fc-widget-content">
                    <div className="fc-scroller fc-day-grid-container" style={{ overflowX: 'hidden', overflowY: 'auto', height: width / 1.75 }}>
                      <Rows
                        firstDate={moment(firstDate)}
                        rowHeight={width / 1.75 / 6}
                        onWidthChanged={this.handleRowsWidthChanged} 
                        mainMonth={mainMonth} 
                        selection={selection} 
                        selected={selected} 
                        unavailable={unavailable}
                        updt={updt} 
                        onDayMouseOver={onDayMouseOver} 
                        onDayClick={onDayClick} />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

const AllotmentCalendarMonthBare2 = sizeMe()(AllotmentCalendarMonthBare);

@observer
class AllotmentCalendarMonth extends React.Component {
  @observable hiDay;
  @observable hiDay1;
  @observable hiDay2;
  @observable selDay2 = false;

  @observable holdDay1;
  @observable holdDay2;

  @observable sharedModel = {
    highlight: computed(() => {
      return this.selDay2 ? [
        {
          start: this.hiStart,
          end: this.hiEnd,
        },       
      ] : []
    }),
  }

  @computed get hiStart() {
    if(!this.hiDay1 || !this.hiDay2) return;
    if(this.hiDay1.isBefore(this.hiDay2)) {
      return this.hiDay1;
    }
    return this.hiDay2;
  }

  @computed get hiEnd() {
    if(!this.hiDay1 || !this.hiDay2) return;
    if(this.hiDay1.isBefore(this.hiDay2)) {
      return this.hiDay2;
    }
    return this.hiDay1;
  }

  @action.bound handleDayMouseOver(date) {
    if(!this.props.selectableAllotment) return
    if(this.selDay2) {
      this.hiDay2 = date;
    }
  }

  @action.bound handleDayClick(date) {
    console.log(`Calendar says: You clicked at: ${moment(date).format('YYYY-MM-DD')}.`)
    date = moment(date);
    if(!this.props.selectableAllotment) return
    this.hiDay = date;
    if(this.selDay2) {
      this.selDay2 = false;
      this.hiDay2 = moment(date);//.add({days: 1});

      this.holdDay1 = this.hiStart;
      this.holdDay2 = this.hiEnd;

      this.props.onIntervalSelected && this.props.onIntervalSelected({start: this.hiStart, end: this.hiEnd})
    } else {
      this.selDay2 = true;
      this.hiDay1 = date;
      this.hiDay2 = date;
    }
  }  

  render() {
    let {selection, selected} = this.props;
    if(selection) {
      selection = {
        start: selection.start,
        end: moment(selection.end)//.add({days: 1}),
      }
      //console.log(`Calendar renders selection [${moment(selection.start).format('YYYY-MM-DD HH:mm')}, ${moment(selection.end).format('YYYY-MM-DD HH:mm')}].`);
    }
    if(selected) {
      selected = {
        start: selected.start,
        end: moment(selected.end)//.add({days: 1}),
      }
      //console.log(`Calendar renders selected [${moment(selected.start).format('YYYY-MM-DD HH:mm')}, ${moment(selected.end).format('YYYY-MM-DD HH:mm')}].`)            
    }
    
    /*if(!moment(selection.end).isSame(moment(selected.end), 'day')) {
      //console.log('DIFFERENT: ', moment(selection.end).format('YYYY-MM-DD'), moment(selected.end).format('YYYY-MM-DD'))
      //throw new Error();
    }*/

    return (
      <Provider sharedModel={this.sharedModel}>
        <AllotmentCalendarMonthBare2
          monthNames={dates.MONTH_NAMES_LONG}
          monthNamesShort={dates.MONTH_NAMES_SHORT}
          dayNames={dates.DAY_NAMES_LONG}
          dayNamesShort={dates.DAY_NAMES_SHORT}
          {...this.props}
          unavailable={this.props.unavailable || []}
          updt={this.props.updt || []}
          selection={this.props.selection /*|| {}*/}
          selected={this.props.selected /*|| {}*/}
          //defaultDate={moment('2017-01-15', 'YYYY-MM-DD')}
          /*selection={{
            start: this.holdDay1,
            end: this.holdDay2,
          }}
          selected={{
            start: moment('2018-02-13', 'YYYY-MM-DD'),
            end: moment('2018-02-15', 'YYYY-MM-DD'),
          }}    */
          /*unavailable={[
            {
              start: moment('2018-02-17', 'YYYY-MM-DD'),
              end: moment('2018-02-25', 'YYYY-MM-DD'),
            },
            {
              start: moment('2018-03-03', 'YYYY-MM-DD'),
              end: moment('2018-03-08', 'YYYY-MM-DD'),
            },        
          ]}  */
          /*updt={[
            {
              start: moment('2018-02-11', 'YYYY-MM-DD'),
              end: moment('2018-02-11', 'YYYY-MM-DD'),
            },
            {
              start: moment('2018-02-27', 'YYYY-MM-DD'),
              end: moment('2018-03-06', 'YYYY-MM-DD'),
            },        
          ]}*/     
          onDayMouseOver={this.handleDayMouseOver}
          onDayClick={this.handleDayClick}
        />
      </Provider>
    )
  }
}


export {
  AllotmentCalendarMonth,
}


// WEBPACK FOOTER //
// ./src/visual/component/AllotmentCalendarMonth.js